import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

import { getImagesByQuery } from './js/pixabay-api.js';
import {
  createGallery,
  clearGallery,
  showLoader,
  hideLoader,
} from './js/render-functions.js';

const form = document.querySelector('.form');

form.addEventListener('submit', handleSubmit);

function handleSubmit(event) {
  event.preventDefault();

  const query = event.currentTarget.elements['search-text'].value.trim();

  if (!query) {
    return;
  }

  clearGallery();
  showLoader();

  getImagesByQuery(query)
    .then(data => {
      if (!data.hits || data.hits.length === 0) {
        iziToast.show({
          message:
            'Sorry, there are no images matching your search query. Please try again!',
          position: 'topRight',
          backgroundColor: '#ef4040',
          messageColor: '#fafafb',
          maxWidth: '432px',
          timeout: 3000,
          close: true,
        });
        return;
      }

      createGallery(data.hits);
    })
    .catch(() => {
      iziToast.show({
        message: 'Something went wrong. Please try again!',
        position: 'topRight',
        backgroundColor: '#ef4040',
        messageColor: '#fafafb',
        maxWidth: '432px',
        timeout: 3000,
        close: true,
      });
    })
    .finally(() => {
      hideLoader();
      form.reset();
    });
}
